import { IPhotoOrderListItem } from '../Entities';

export enum ProductFilterOption {
    All = -1,
    Express = 0,
    ExpressWeekend = 1,
    Film = 2,
    Text = 3,
    Visualization = 4
}

export function filterByProduct(
    orders: IPhotoOrderListItem[],
    product: ProductFilterOption | string
): IPhotoOrderListItem[] {
    switch (Number(product) as ProductFilterOption) {
        case ProductFilterOption.Express:
            return orders.filter((x) => x.isExpress);
        case ProductFilterOption.ExpressWeekend:
            return orders.filter((x) => x.isExpressWeekend);
        case ProductFilterOption.Film:
            return orders.filter((x) => x.isFilm);
        case ProductFilterOption.Text:
            return orders.filter((x) => x.isText);
        case ProductFilterOption.Visualization:
            return orders.filter((x) => x.isVisualization);
        default:
            return orders;
    }
}
